export const RoutesPaths = {
  HOME: "/",
  FLOW: "/flow",
};
